import IOrder_State from "../../../models/IOrder_State";
import OrderStatesEnum from "../../../models/OrderStatesEnum";
import OwPill from "../OwPill/OwPill";
import { getStatusConfig, formatStatusName } from "./orderStatusConfig";
import "./OrderStatusPill.scss";

type OrderStatusPillProps = {
    orderState?: IOrder_State;
    orderStateId?: OrderStatesEnum;
    className?: string;
    showIcon?: boolean;
};

export const OrderStatusPill = (props: OrderStatusPillProps) => {
    const { orderState, orderStateId, className, showIcon } = props;

    // Get the status ID from either prop
    const statusId = orderState?.id ?? orderStateId;

    if (statusId === undefined) {
        return null;
    }

    // Get the display name - prefer IOrder_State.name if available
    const displayName = orderState?.name || formatStatusName(statusId);

    // Get color configuration
    const config = getStatusConfig(statusId);

    // Build className string
    const pillClassName = [config.bgClass, config.textClass, className].filter(Boolean).join(" ");

    return (
        <OwPill
            title={displayName.toLowerCase()}
            className={pillClassName}
            skipTranslate={false}
            leftIconClass={showIcon ? getStatusIcon(statusId) : undefined}
        />
    );
};

const getStatusIcon = (statusId: OrderStatesEnum): string | undefined => {
    switch (statusId) {
        case OrderStatesEnum.COMPLETED:
        case OrderStatesEnum.APPROVED:
            return "fas fa-check";
        case OrderStatesEnum.CANCELLED:
            return "fas fa-times";
        case OrderStatesEnum.DELIVERED:
        case OrderStatesEnum.SHIPPED:
            return "fas fa-truck";
        case OrderStatesEnum.PICKED_UP:
            return "fas fa-box";
        case OrderStatesEnum.DELAYED:
            return "fas fa-clock";
        case OrderStatesEnum.PENDING:
        case OrderStatesEnum.AWAITING_REVIEW:
        case OrderStatesEnum.UNDER_REVIEW:
            return "fas fa-hourglass-half";
        case OrderStatesEnum.IN_PROGRESS_PACKING:
        case OrderStatesEnum.PRINTING:
        case OrderStatesEnum.SEWING:
        case OrderStatesEnum.MATERIAL_CUTTING:
            return "fas fa-cog";
        default:
            return undefined;
    }
};

export default OrderStatusPill;
